import { Component, OnInit } from '@angular/core';
import { InputAutocompleteModel } from 'src/app/models/input-autocomplete.model';
import { AuthenticationService } from '../../authentication/authentication/authentication.service';
import { CompanyRoleResponse } from 'src/app/models/company.model';
import { ResponseObject } from 'src/app/models/response-object.model';
import { HttpErrorResponse } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { ButtonLoading } from 'src/app/models/button-loading.model';
import { CompanyService } from 'src/app/services/company.service';
import { UserSaved } from 'src/app/models/user.model';
import { InvoiceSaleService } from '../../inventory/sales/invoice-sale/invoice-sale.service';
import { PurchasesService } from 'src/app/services/purchases.service';
declare let $: any;

@Component({
  selector: 'app-delete-duplicates',
  templateUrl: './delete-duplicates.component.html',
  styleUrls: ['./delete-duplicates.component.scss', '../../../../../assets/css/tabs.scss']
})
export class DeleteDuplicatesComponent {
  inputs = new InputAutocompleteModel("", false, true, "", "fa-asterisk", "", "", null, []);
    allCompanies: CompanyRoleResponse[] = [];
    companies: CompanyRoleResponse[] = [];
    selected: CompanyRoleResponse = null;
    timeout = null;
    accountSelected = null;
    upload = new ButtonLoading("btn-success", false, "Eliminar", "fa-trash");
    user: UserSaved = null;
  
    startDate = "";
    endDate = "";
  
    constructor(
      private authService: AuthenticationService,
      private toastService: ToastrService,
      private companyService: CompanyService,
      private invoiceService: InvoiceSaleService,
      private purchasesService: PurchasesService
    ) {
      this.companies = JSON.parse(this.authService.getCurrentUser()).companyRoles;
      this.user = this.authService.getUser();
      this.allCompanies = this.companies;
    }
  
    ngOnInit(): void {
        if (this.user.contadorGT) {
          this.getAssociatedCompanies();
        }
    }
    
    getAssociatedCompanies() {
      this.companyService.getCompaniesAssociatedToPartner(this.user.id).subscribe({
        next: (response: ResponseObject) => {
          this.companies = response.data;
          this.allCompanies = this.companies;
        },
        error: (error: HttpErrorResponse) => {
          this.toastService.error("Error al obtener las companias asociadas");
        }
      })
    }
  
    searchCompany() {
      clearTimeout(this.timeout);
      this.inputs.class = "typing";
      this.timeout = setTimeout(() => {
        this.companies = this.allCompanies.filter((company) => {
          var val = this.inputs.value.toLowerCase();
          return company.alphanumericId.toLowerCase() == val || company.companyName.toLowerCase().includes(val) || company.companyNIT.toLowerCase().includes(val);
        });
        this.inputs.verified = false;
        if (this.companies.length > 0) {
          this.inputs.class = "fa-list";
        } else {
          this.inputs.class = "fa-xmark";
        }
      }, 300);
    }
  
  
    selectCompany(selected: any) {
      this.inputs.value = selected.alphanumericId + " - " + (selected.companyNIT ? selected.companyNIT : selected.nit) + " - " + (selected.companyName ? selected.companyName : selected.name);
      this.inputs.verified = true;
      this.inputs.class = "fa-circle-check";
      this.selected = selected;
    }
  
    deleteInvoices(){
      const startDateMillis = new Date(this.startDate).getTime();
      const endDateMillis = new Date(this.endDate).getTime();
  
      if (!this.selected || !this.startDate || !this.endDate) {
        this.toastService.error("Faltan parámetros para eliminar las facturas duplicadas.");
        return;
      }
  
      this.invoiceService.deleteDuplicatedInvoices(this.selected.companyId, startDateMillis, endDateMillis)
      .subscribe(
          (response) => {
            if (response.success && response.data) {
              this.toastService.success('Cantidad de facturas de venta eliminadas: ' + response.data.length);
            } else {
              this.toastService.error('No se encontraron datos en la respuesta. Para eliminar Facturas de venta');
            }
          },
          (error) => {
            this.toastService.error("Error eliminando facturas duplicadas de venta");
          }
      );

      this.purchasesService.deleteDuplicatedInvoices(this.selected.companyId, startDateMillis, endDateMillis)
      .subscribe(
          (response) => {
            if (response.success && response.data) {
              this.toastService.success('Cantidad de facturas de proveedor eliminadas: ' + response.data.length);
            } else {
              this.toastService.error('No se encontraron datos en la respuesta. Para eliminar Facturas de proveedor');
            }
          },
          (error) => {
            this.toastService.error("Error eliminando facturas duplicadas de proveedor");
          }
      );
    }

}
